import { EnhancedAccordion } from 'components/enhanced/accordion/EnhancedAccordion';
import { IProductWarehouse } from 'features/inventory/products/types';
import { IPurchaseOrderRow } from 'features/inventory/purchase-orders/types';
import { IStockQuantity } from 'features/inventory/stock/types';
import { Option } from 'shared/types/general';
import InfoBoxPurchaseRequestCard from './InfoBoxPurchaseRequestCard';
import PurchaseRequestLineForm from './form/PurchaseRequestLineForm';

interface PurchaseRequestProps {
  productOptions: Option[];
  contractOptions: Option[];
  warehouseOptions: Option[];
  maxUnits: number;
  maxDiscountedUnits: number;
  visibleProduct: {
    code: string;
    description?: string;
    stockQuantities?: IStockQuantity[];
    productWarehouse?: IProductWarehouse[];
    orderLines?: IPurchaseOrderRow[];
    consume?: any[];
    unitPrice?: string;
    packaging?: string;
    uom?: string;
  } | null;
  onSubmitRow: (data: any) => void;
  setProductToAdd: (product: any) => void;
  setContractToAdd: (contract: any) => void;
  setWarehouseToAdd: (warehouse: any) => void;
  automaticGenerated: boolean;
}

const PurchaseRequestAccordion = ({
  productOptions,
  contractOptions,
  warehouseOptions,
  maxUnits,
  maxDiscountedUnits,
  visibleProduct,
  onSubmitRow,
  setProductToAdd,
  setContractToAdd,
  setWarehouseToAdd,
  automaticGenerated
}: PurchaseRequestProps) => {
  return (
    <EnhancedAccordion
      title={'Aggiungi Articolo'}
      subtitle={"Configura la riga d'acquisto e visualizza la scheda informativa del prodotto."}>
      <div className="grid grid-cols-2 gap-4">
        {/* Prima colonna con il form per la richiesta di acquisto */}
        <PurchaseRequestLineForm
          onSubmit={onSubmitRow}
          products={productOptions}
          setProduct={setProductToAdd}
          contracts={contractOptions}
          setContract={setContractToAdd}
          warehouses={warehouseOptions}
          setWarehouse={setWarehouseToAdd}
          maxUnits={maxUnits}
          maxDiscountedUnits={maxDiscountedUnits}
          automaticGenerated={automaticGenerated}
        />

        {/* Seconda colonna con il card di informazioni sul prodotto */}
        <InfoBoxPurchaseRequestCard
          product_code={visibleProduct?.code || null}
          product_description={visibleProduct?.description || undefined}
          stockQuantities={visibleProduct?.stockQuantities || null}
          productWarehouse={visibleProduct?.productWarehouse || null}
          orderLines={visibleProduct?.orderLines || null}
          consumes={visibleProduct?.consume || null}
          unitPrice={visibleProduct?.unitPrice || null}
          packaging={visibleProduct?.packaging || undefined}
          uom={visibleProduct?.uom || undefined}
        />
      </div>
    </EnhancedAccordion>
  );
};

export default PurchaseRequestAccordion;
